import { Box } from "@mui/material";
import { EntityTemplateStep } from "../../EntityTemplate.types.ts";
import { useCreateEditEntityTemplateStepDialog } from "./CreateEditEntityTemplateStepDialog.hooks.ts";
import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { isNullOrWhitespace } from "../../../common/stringOperations.ts";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";

export interface CreateEditEntityTemplateStepDialogProps {
    entityTemplateId: string;
    step?: EntityTemplateStep;
    onCloseDialog: () => void;
    onStepSaved: () => void;
}

function CreateEditEntityTemplateStepDialog(props: CreateEditEntityTemplateStepDialogProps) {
    const isEdit = props.step;
    const { translateString } = useTranslation();
    const { saveModel, onSaveStep, isSaving, showError, modelUpdater } = useCreateEditEntityTemplateStepDialog(props);

    return (
        <DotLegalDialog
            header={isEdit ? translateString("editStep") : translateString("createStep")}
            buttonOkText={isEdit ? translateString("save") : translateString("create")}
            onOkClick={onSaveStep}
            okButtonDisabled={isSaving}
            onDialogClose={props.onCloseDialog}
            open
            size="sm"
        >
            <DotLegalTextField
                label={translateString("name")}
                value={saveModel}
                onChange={modelUpdater.onStepNameChange}
                errorText={showError && isNullOrWhitespace(saveModel) ? translateString("nameRequired") : undefined}
                debounce={false}
                autoFocus
            />
        </DotLegalDialog>
    );
}

export default CreateEditEntityTemplateStepDialog;
